<!--
 * @Descripttion: 输出控件
 * @Author: zenghua.wang
 * @Date: 2021-07-19 14:01:54
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-10 10:56:25
-->
<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false"
    :modal-append-to-body="false" append-to-body center width="70%">
    <el-form ref="outputForm" size="small" label-width="120px" label-position="left" label-suffix=":"
      :model="data.apisMainOutCtls" :rules="rules">
      <el-form-item label="名称" prop="ctlsName">
        <el-input placeholder="请输入" clearable style="width: 100%" v-model="data.apisMainOutCtls.ctlsName"></el-input>
      </el-form-item>
    </el-form>

    <div class="output-panel">
      <div>
        <el-button icon="el-icon-plus" type="primary" size="small" @click="onAdd">新增</el-button>
        <el-button icon="el-icon-finished" type="success" size="small" @click="onGeneration">一键输出</el-button>
        <el-button icon="el-icon-delete" type="danger" size="small" @click="onClear">一键清除</el-button>
      </div>
      <div class="output-tips">
        <span>备注：</span>
        <div class="output-tips-text">
          <p>1、若有相同属性（例如：${id}），可在table查询控件 -> 字段选择 进行别名设置。</p>
          <p>2、拖拽表格的行上下移动可以进行排序哦！</p>
        </div>
      </div>
      <el-table size="small" tooltip-effect="dark" style="width: 100%" border fit id="dragSortOutput" row-key="id"
        :data="data.apisMainOutCtlsDataList">
        <el-table-column label="变量" align="center">
          <template slot-scope="scope">
            <el-select size="small" style="width: 100%" clearable placeholder="请选择" v-model="scope.row.variableSource"
              @visible-change="fixZoom">
              <el-option v-for="(item, index) in cellList" :key="index" :label="item.name"
                :value="item.name"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="属性（别名/字段名）" align="center">
          <template slot-scope="scope">
            <el-input size="small" clearable placeholder="例如: ${id}" v-model="scope.row.variablePath" />
          </template>
        </el-table-column>
        <el-table-column label="输出路径" align="center">
          <template slot-scope="scope">
            <el-input size="small" clearable placeholder="例如: myId" v-model="scope.row.outPutPath" />
          </template>
        </el-table-column>
        <el-table-column label="排序" align="center" width="180">
          <template slot-scope="scope">
            <el-input size="small" clearable placeholder="请输入" v-model="scope.row.sortting" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onDelete(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-button icon="el-icon-plus" type="primary" size="small" @click="onAdd">新增</el-button>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import mysortable from 'sortablejs'
import { createId, isEmpty } from '@/apisManage/utils'
export default {
  name: 'ApisOutput',
  components: {},
  inject: ['main'],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '输出配置'
    },
    tenantId: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    change: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      visible: this.show,
      cellList: [],
      rules: {
        ctlsName: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  computed: {},
  watch: {
    show(val) {
      if (val) {
        // 变量
        let cells = this.main.editor.parseXml2Json('vertex')
        this.cellList = cells.filter((item) => {
          return (item.value === 'table' || item.value === 'http') && item.name
        })
        // 赋值
        this.data.apisMainOutCtls.id = this.main.selectCell.id
        // 拖拽排序
        this.$nextTick(() => {
          this.onDragSort()
        })
      }
      this.visible = val
    },
    visible: {
      handler(val) {
        this.sortable = null
        this.$emit('update:show', val)
      },
      deep: true
    }
  },
  methods: {
    // 一键输出
    onGeneration() {
      let list = []
      let sortting = 0
      this.main.data.apisTbCtlsModels.map((item, index) => {
        item.apisTbCtlsReturnList.forEach((el) => {
          if (el.isOut == 1) {
            sortting++
            let variableSource = !isEmpty(el.otherName) ? el.otherName : el.field
            list.push({
              id: createId(),
              mainOutCtlsId: this.data.apisMainOutCtls.id || createId('respons'),
              tenantId: this.tenantId,
              outPutPath: variableSource,
              variablePath: '${' + variableSource + '}',
              variableSource: this.cellList[index]['name'],
              sortting: sortting
            })
          }
        })
      })
      this.$set(this.data, 'apisMainOutCtlsDataList', list)
    },
    // 一键清除
    onClear() {
      this.data.apisMainOutCtlsDataList = []
    },
    onAdd() {
      this.data.apisMainOutCtlsDataList =
        this.data.apisMainOutCtlsDataList.filter((item) => {
          return item.variableSource
        })
      let len = this.data.apisMainOutCtlsDataList.length
      this.data.apisMainOutCtlsDataList.push({
        id: createId(),
        mainOutCtlsId: this.data.apisMainOutCtls.id || createId('respons'),
        tenantId: this.tenantId,
        outPutPath: null,
        variablePath: null,
        variableSource: null,
        sortting: len + 1
      })
    },
    onDelete(index) {
      this.data.apisMainOutCtlsDataList.splice(index, 1)
    },
    onSubmit() {
      this.$refs.outputForm.validate((bool) => {
        if (bool) {
          this.$emit('change', 'respons', this.data)
          this.visible = false
        }
      })
    },
    // 行拖拽排序
    onDragSort() {
      let self = this
      let tbody = document.querySelector('#dragSortOutput tbody')
      if (tbody) {
        // 修复zoom
        if (window.navigator.userAgent.indexOf('Chrome') > 0) {
          tbody.style.zoom = 1 / window.scale || 1
        }
        // sortable
        this.sortable = mysortable.create(tbody, {
          disabled: false,
          animation: 200,
          group: 'respons',
          sort: true,
          draggable: '.el-table__row',
          direction: 'vertical',
          onEnd: (e) => {
            let list = self.data.apisMainOutCtlsDataList
            let item = list.splice(e.oldIndex, 1)[0]
            list.splice(e.newIndex, 0, item)
            // 选择字段排序处理
            list.forEach((el, index) => {
              el.sortting = index + 1
            })
            this.$nextTick(() => {
              self.data.apisMainOutCtlsDataList = list
            })
          }
        })
      }
    },
    // 修复zoom导致的bug
    fixZoom(visible) {
      if (window.navigator.userAgent.indexOf('Chrome') > 0) {
        let select = document.querySelectorAll('.el-select-dropdown')
        if (visible) {
          select.forEach((item) => {
            item.style.zoom = 1 / window.scale || 1
          })
        } else {
          setTimeout(() => {
            select.forEach((item) => {
              item.style.zoom = 'inherit'
            })
          }, 500)
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.onDragSort()
    })
  }
}
</script>
<style lang="scss" scoped>
.output {
  &-panel {
    padding: 15px 0;
  }

  &-tips {
    display: flex;
    flex-direction: row;
    padding: 12px 0;
    color: #999;

    &-text {
      flex: 4;

      p {
        margin: 0;
      }
    }
  }
}

:deep(#dragSortOutput) {
  tbody {
    zoom: 1.2;

    td {
      padding: 5px 0;
    }

    .el-input {
      font-size: 12px;
    }
    .el-input__inner {
      height: 28px;
      line-height: 28px;
    }
  }
}
</style>
